
import React from "react";
import { Link } from "react-router-dom";
import SRList from "../component/List";
import AkkhorLayout from "../layout/akkhor";

export default function ListCompany() {

  let columns = [
    { name: "id", label: "ID" },
    { name: "title", label: "Tiêu đề" },
    { name: "company_code", label: "MSNV" },
    { name: "vanthu_code", label: "Mã văn thư" },
     {
      name: "master1", label: "Người đại diện",
      options: {
        filter: false, sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ?<>
            <div className="w-100 d-flex"><span>Họ tên: </span><strong className="ml-2">{tableMeta.mastername}</strong></div>
            <div className="w-100 d-flex"><span>Chức vụ: </span><strong className="ml-2">{tableMeta.master_cv}</strong></div>
          </> : ''
        },
      }
    },
    { name: "datecreate",label: "Ngày tạo",}
    
  ];


  return (<AkkhorLayout idrole="list-company">
    <div className="breadcrumbs-area">
      <ul>
          <li>
              <Link to="/">Trang chủ</Link>
          </li>
          
          <li>Quản lý công ty</li>
      </ul>
    </div>
    <SRList name="company" idrole="list-company" title="Công ty" defaultLimit={50}  serverSide={true} columns={columns}></SRList>
  </AkkhorLayout>);
}
